import React, { useEffect, useState } from "react";

//* Import Utilities and Helpers
import apiUtils from "../../../utilities/apiUtils";

//* Import Context API
import { useBracketState } from "../context/BracketStateContext";

const LoadTemplateModal = ({ onClose, activeTeam, teamList, pickTemplate }) => {
  const { loading, sendGETRequest } = apiUtils();

  //* Context API
  const { setIsLoading } = useBracketState();

  //* States
  const [templateList, setTemplateList] = useState([]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (activeTeam > 0 && teamList.skybox.includes(activeTeam)) {
      setActive(activeTeam);
      loadTemplates(activeTeam);
    } else {
      setActive(0);
    }
  }, [activeTeam]);

  const changeTeam = ({ target }) => {
    const value = target.value;
    setActive(value);
    loadTemplates(value);
  };

  //* Load template but team id [SKYBOX]
  const loadTemplates = async (teamId) => {
    if (!teamId || teamId == 0) {
      return setTemplateList([]);
    }

    const { data } = await sendGETRequest(
      `brackets-template/list/${teamId}`,
      {},
      true
    );

    if (data.status) {
      setTemplateList(data.data);
    }
  };

  return (
    <div className="eventModal">
      <div className="modal-content">
        <div className="modal-body">
          <div className="row">
            <div className="col-md-12 mb-3">
              <div className="event-modal-header">
                <h4 className="text-center mb-3 flex-grow-1">
                  START WITH A TEMPLATE
                </h4>
                <button
                  type="button"
                  className="btn btn-secondary modalClose"
                  data-dismiss="modal"
                  onClick={onClose}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>
              <select
                name="teams"
                id="template_team"
                className="form-control template_team_dropdown"
                value={active}
                onChange={changeTeam}
              >
                <option key="0" value="0">
                  Select Teams
                </option>
                {teamList.skybox.map((team) => (
                  <option key={team} value={team}>{`${team} TEAMS`}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="row mb-5 skyboxTemplateList">
            {templateList.length > 0 &&
              !loading &&
              templateList.map((template) => (
                <div
                  key={template.bracket_template_id}
                  className="col-md-6 skybox_template"
                >
                  <div className="card">
                    <div className="card-header">{template.formatted_name}</div>
                    <div className="card-body">
                      <img src={template.image} alt={template.formatted_name} />
                      <div className="overlay">
                        <button
                          className="btn btn-primary"
                          onClick={() =>
                            pickTemplate({
                              bracket_template_id: template.bracket_template_id,
                            })
                          }
                        >
                          Select
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>

          {teamList.local.length > 0 && (
            <>
              <div className="row">
                <div className="col-md-12 text-center">
                  <b>YOUR TEMPLATES</b>
                </div>
              </div>
              <div className="row localTemplateList">
                {teamList.local.map((team) => (
                  <div className="col-md-4 skybox_template" key={team.id}>
                    <div className="card">
                      <div className="card-body">
                        <p className="mt-2">
                          {team.template_name ? team.template_name : "-"}
                        </p>
                      </div>
                      <div className="overlay">
                        <button
                          className="btn btn-primary"
                          onClick={() =>
                            pickTemplate({
                              value: team.id,
                            })
                          }
                        >
                          Select
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoadTemplateModal;
